import React from 'react';
import { Helmet } from 'react-helmet';

import { spanish } from '../../../config/config';
import Success from '../../../components/Checkout/Success';

const SuccessPage = () => (
  <div>
    <Helmet title={spanish ? '!Gracias por tu compra!' : 'Thank You!'} />
    <Success />
  </div>
);

export default SuccessPage;
